export default __webpack_public_path__ + "static/media/featuredAds.12197b72.svg";